import React, { useEffect, useRef } from 'react';
import Regex from '../../utils/regex';
import { Input, message } from 'antd';
import { Container, FieldTitle, RowSection } from './styles';
import { withTranslation } from 'react-i18next';
import { SIGNATURE_SETTINGS } from './translationValues';

const NAMESPACES = ['SIGNATURE_SETTINGS'];

const defaultGetElementDetails = el => el.elementDetails;

const SignatureSettings = props => {
  const { element, style = {}, t, onFieldNameChange, OPTIONS_KEY = 'validations', FIELD_NAME_KEY = 'fieldName', getElementDetails = defaultGetElementDetails } = props;

  const forwardRef = useRef(null);
  const fieldNameRef = useRef(null);
  const details = getElementDetails(element);
  const fieldName = details[OPTIONS_KEY][FIELD_NAME_KEY];

  useEffect(() => {
    if (forwardRef.current) {
      forwardRef.current = null;
    } else {
      if (fieldNameRef.current?.input) fieldNameRef.current.input.value = details[OPTIONS_KEY][FIELD_NAME_KEY];
    }
  }, [details]);

  return (
    <Container style={style}>
      <FieldTitle isTitle={1}>
        {t(
          SIGNATURE_SETTINGS.SIGNATURE_SETTINGS_LABEL.key,
          SIGNATURE_SETTINGS.SIGNATURE_SETTINGS_LABEL.value,
        )}
      </FieldTitle>
      <RowSection>
        <FieldTitle>
          {t(SIGNATURE_SETTINGS.FIELD_NAME_LABEL.key, SIGNATURE_SETTINGS.FIELD_NAME_LABEL.value)}*
        </FieldTitle>
          <Input
            ref={fieldNameRef}
            placeholder={t(
              SIGNATURE_SETTINGS.FIELD_NAME_PLACEHOLDER.key,
              SIGNATURE_SETTINGS.FIELD_NAME_PLACEHOLDER.value,
            )}
            onChange={e => {
              if (Regex.NO_SPLCHAR_EXCEPT_HYPHEN.test(e.target.value)) {
                message.error(
                  t(
                    SIGNATURE_SETTINGS.FIELD_NAME_SPECIAL_CHARACTER_ERROR_MESSAGE.key,
                    SIGNATURE_SETTINGS.FIELD_NAME_SPECIAL_CHARACTER_ERROR_MESSAGE.value,
                  ),
                );
                e.target.value = details[OPTIONS_KEY][FIELD_NAME_KEY];
              } else {
                forwardRef.current = e.target;
                onFieldNameChange(e.target.value);
              }
            }}
            defaultValue={fieldName}
          />
      </RowSection>
    </Container>
  );
};

export default withTranslation(NAMESPACES)(SignatureSettings);
